<template>
  <div class="row">
    <div class="col-sm-6">
      <v-text-field
        v-model="password"
        label="Default Password"
        outlined
        required
        class="pb-2"
      ></v-text-field>
    </div>
    <div class="col-sm-6">
      <v-select
        v-model="office"
        :items="office_items"
        item-text="name"
        item-value="id"
        label="Offices"
        outlined
      ></v-select>
    </div>
  </div>
</template>
<script>
import { mapState,mapActions } from "vuex";

export default {
  data() {
    return {
      password: "",
      office: ""
    };
  },
  computed: {
    ...mapState({
      office_list: (state) => state.offices.offices,
    }),
      ...mapActions(["fetchOffices", "updateOffice", "fetchUsersByOffice"]),
    office_items() {
      return this.office_list.map((x) => {
        return {name:x.name,id: x.id};
      });
    },
  },
  watch: {
    password: function(val) {
      this.$store.dispatch("file_imports/set_default_password", val);
    },
    office: function(val) {
      this.$store.dispatch("file_imports/set_default_office", val);
    },
  },
  mounted: function() {
    (this.password = ""), (this.office = "");
    this.fetchOffices
  },
};
</script>
